import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Protected from "../components/Protected";
import { REMITTANCE_SIGNUP } from "../config/constants";
import { REMITTANCE_HOME_PATH, REMITTANCE_NB_HOME_PATH } from "../constants";
import FullScreenSkeleton from "../components/Skeletons/FullScreenSkeleton";
// Lazy loaded pages (default exports)
const Signup = lazy(() => import("../pages/SignUp"));
const Login = lazy(() => import("../pages/Login"));
const Resetpassword = lazy(() => import("../pages/ResetPassword"));
// const Rewards = lazy(() => import("../pages/accounts/rewards/Rewards"));
const GetApp = lazy(() => import("../pages/GetApp"));
const Plaid = lazy(() => import("../pages/Plaid"));
const ManageAccounts = lazy(() => import("../pages/ManageAccounts"));
const UserForm = lazy(() => import("../pages/UserForm"));
const Withdrawal = lazy(() => import("../pages/Withdrawal"));
const SignupV2 = lazy(() => import("../pages/SignupV2"));
const WillowSignup = lazy(() => import("../pages/WillowSignup"));
const WillowSignupSuccess = lazy(() => import("../pages/WillowSignupSuccess"));
const VerifyOtp = lazy(() => import("../pages/toi/VerifyOtp"));
const TOILandingPage = lazy(() => import("../pages/toi/TOILandingPage"));
const TOIAppSignUp = lazy(() => import("../pages/toi/toiAppSignUp"));
const VerifyDetails = lazy(() => import("../pages/VerifyDetails"));
const RemittanceCalcuator = lazy(() =>
  import("../pages/Remittance/RemittanceCalculator")
);
const Reauthenticate = lazy(() => import("../pages/Remittance/Reauthenticate"));
const RemittanceDashboard = lazy(() =>
  import("../pages/Remittance/RemittanceDashboard")
);
const RemittanceRateHome = lazy(() =>
  import("../pages/Remittance/RemittanceRateHome")
);
const CrosswalkSignup = lazy(() => import("../pages/cricbuzz/CrosswalkSignup"));
const Insomania = lazy(() => import("../pages/cricbuzz/insomania/Insomania"));
// Named export -> map to default for React.lazy
const TOIThemeProvider = lazy(() =>
  import("../pages/toi/TOIThemeProvider").then((module) => ({
    default: module.TOIThemeProvider,
  }))
);
const TOIEmailUpdate = lazy(() => import("../pages/toi/toiEmailUpdate"));
const TOIKycPage = lazy(() => import("../pages/toi/toiKycPage"));

function RouteController() {
  return (
    <Router basename="/getapp">
      <Suspense fallback={<FullScreenSkeleton />}>
        <Routes>
          <Route index element={<Login />} />
          {/* <Route path="/" element={<Navigate to="/login" />} /> */}
          <Route path="/signup" element={<Signup />} />
          <Route path="/signup/v2" element={<SignupV2 />} />
          <Route path="/login" element={<Login />} />
          <Route path="/resetPassword" element={<Resetpassword />} />
          <Route path="/user-form" element={<UserForm />} />
          <Route path="/withdrawal" element={<Withdrawal />} />
          <Route
            path="/plaid"
            element={
              <Protected>
                <Plaid />
              </Protected>
            }
          />
          <Route
            path="/getApp"
            element={
              <Protected>
                <GetApp />
              </Protected>
            }
          />
          <Route path="/verifyDetails" element={<VerifyDetails />} />
          <Route
            path="/accounts"
            element={
              <Protected>
                <ManageAccounts />
              </Protected>
            }
          />
          <Route
            path="/remittance/calculator"
            element={<RemittanceCalcuator />}
          />
          {/* <Route
          path="/rewards"
          element={
            <Protected>
              <Rewards />
            </Protected>
          }
        ></Route> */}
          <Route path="/willow/forget-password" element={<WillowSignup />} />
          <Route path="/willow/success" element={<WillowSignupSuccess />} />
          <Route path="/cricbuzz" element={<CrosswalkSignup />} />
          <Route path="/crosswalk/signup" element={<Insomania />} />
          <Route path="/remittance/toi" element={<Insomania />} />

          <Route
            path="/remittance/signup"
            element={<SignupV2 screenType={REMITTANCE_SIGNUP} />}
          />

          <Route path="/verify-otp" element={<VerifyOtp />} />

          <Route
            path="/toi/landing"
            element={
              <TOIThemeProvider>
                <TOILandingPage />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/toi/signup"
            element={
              <TOIThemeProvider>
                <TOIAppSignUp />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/toi/email-update"
            element={
              <TOIThemeProvider>
                <TOIEmailUpdate />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/toi/kyc"
            element={
              <TOIThemeProvider>
                <TOIKycPage />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/remittance/bankadd"
            element={
              <Protected>
                <Plaid />
              </Protected>
            }
          />
          <Route
            path="/re-authenticate"
            element={
              <Protected>
                <TOIThemeProvider>
                  <Reauthenticate />
                </TOIThemeProvider>
              </Protected>
            }
          />
          <Route
            path={REMITTANCE_NB_HOME_PATH}
            element={
              <Protected>
                <RemittanceDashboard />
              </Protected>
            }
          />
          <Route path={REMITTANCE_HOME_PATH} element={<RemittanceRateHome />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default RouteController;
